import React, {Component} from 'react';
//import {SESSION_USER} from '../../constants';
const $=require('jquery');
$.DataTable=require('datatables.net')

export class PeopleTable extends Component {

	componentDidMount(){
		//let user = JSON.parse(localStorage.getItem(SESSION_USER));
		//console.log(localStorage.getItem(SESSION_USER));
	//	console.log(localStorage.getItem(SESSION_USER));
//
        this.$el=$(this.el)
        this.$el.DataTable({
        	      //ajax: {
	                //url: 'allService',
	                //dataSrc: ''
	               //},
                    data:this.props.data,
                    columns: this.props.cols
		            
        })
     }
	
	componentWillUnmount(){
          this.el.dataTable.destory(true);
	}
	render(){
		return <table className="display nowrap table table-hover table-striped table-bordered dataTables-user dataTable no-footer" width="100%" ref={el =>this.el=el}> 
          </table>
		
	}



}